// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3PwiU","title":"Header_title__3Foms","side":"Header_side__1hP9y"};